import { Route } from '@angular/router';
import { Path } from '@notfall/feat-core';

export const appRoutes: Route[] = [
  {
    path: Path.LANDING,
    loadChildren: () => import('@notfall/feat-landing').then((c) => c.landingRoutes),
    title: 'landing-page.description.title',
    data: {
      description: 'landing-page.meta.description',
    },
  },
  {
    path: Path.EMERGENCY_CALL,
    loadChildren: () => import('@notfall/feat-emergency-call').then((c) => c.emergencyCallRoutes),
    title: 'emergency-call.page.title',
    data: {
      description: 'emergency-call.page.meta.description',
    },
  },
  {
    path: Path.SYMPTOM_CHECKER,
    loadChildren: () => import('@notfall/feat-symptom-checker').then((c) => c.symptomCheckerRoutes),
    title: 'symptom-checker.page.title',
    data: {
      description: 'symptom-checker.page.meta.description',
    },
  },
  {
    path: Path.UNSURE,
    loadChildren: () => import('@notfall/feat-unsure').then((c) => c.unsureRoutes),
  },
  {
    path: Path.TELEMEDICAL_CONSULTING,
    loadChildren: () => import('@notfall/feat-telemedical-consulting').then((c) => c.telemedicalConsultingRoutes),
  },
  {
    path: Path.MEDIC_CENTERS,
    loadChildren: () => import('@notfall/feat-medic-centers').then((c) => c.medicCentersRoutes),
  },
  {
    path: Path.PHARMACIES,
    loadChildren: () => import('@notfall/feat-medic-centers').then((c) => c.pharmacyRoutes),
  },
  {
    path: Path.OCCUPANCIES,
    loadChildren: () => import('@notfall/feat-medic-centers').then((c) => c.occupancyEmbedRoutes),
  },
  {
    path: Path.IMPRESSUM,
    loadChildren: () => import('@notfall/feat-impressum').then((c) => c.impressumRoutes),
    title: 'impressum.page.title',
    data: {
      description: 'impressum.page.meta.description',
    },
  },
  {
    path: Path.FAQ,
    loadChildren: () => import('@notfall/feat-faq').then((c) => c.faqRoutes),
    title: 'faq.page.title',
    data: {
      description: 'faq.page.meta.description',
    },
  },
  {
    path: Path.PRIVACY,
    loadChildren: () => import('@notfall/feat-privacy').then((c) => c.privacyRoutes),
    title: 'privacy.page.title',
    data: {
      description: 'privacy.page.meta.description',
    },
  },
  {
    path: 'playground',
    loadChildren: () => import('@notfall/feat-playground').then((c) => c.playgroundRoutes),
  },
];
